import React, { lazy, Suspense } from 'react';

// the emoji library is about 80 KB: it is downloaded when someone first opens the picker, not with every page
const EmojiPickerReact = lazy(() => import('emoji-picker-react'));

// Full emoji library (search, categories, skin tones, recently used) from `emoji-picker-react`.
// Kept identical in the admin panel and the member site.
const currentTheme = () => {
    const root = document.documentElement;
    const adminDark = root.dataset.adminTheme === 'dark';
    const siteDark = root.dataset.theme === 'dark';
    return adminDark || siteDark ? 'dark' : 'light';
};

const EmojiPicker = ({ onPick }) => (
    <div className="emoji-picker emoji-picker--full" role="dialog" aria-label="Emoji picker">
        <Suspense fallback={<div style={{ height: 380 }} aria-busy="true" />}>
            <EmojiPickerReact
                onEmojiClick={data => onPick(data.emoji)}
                theme={currentTheme()}
                width="100%"
                height={380}
                lazyLoadEmojis
                searchPlaceholder="Search emoji"
                previewConfig={{ showPreview: false }}
            />
        </Suspense>
    </div>
);

export default EmojiPicker;
